import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentConfig } from '../../interfaces/environment.interface';

import { AidaSurveyEligibility } from '../../interfaces/aida.interface';

@Injectable({ providedIn: 'root' })
export class AidaService {
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;
  private readonly _aidaBaseUrl = 'buyers/v2/aida';

  constructor(
    private _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  public checkSurveyEligibility(
    surveyId: number
  ): Observable<AidaSurveyEligibility> {
    return this._http.get<AidaSurveyEligibility>(
      `${this._baseUrl}/${this._aidaBaseUrl}/eligibility-check/${surveyId}`
    );
  }
}
